import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { MenuElement } from 'src/app/shared/model/menu-element';
import { buildResetStopsMenuElements } from './reset-stops-menu';

@Component({
  selector: 'app-line-direction-counters-reset-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  readonly menuElements: readonly MenuElement[];
  mainElement: MenuElement | null = null;

  constructor(private route: ActivatedRoute, private settings: UserSettingsService) {
    this.menuElements = buildResetStopsMenuElements(settings);
  }

  ngOnInit(): void {
    const currentPath = this.route.snapshot.routeConfig?.path;
    const mainElement = this.menuElements?.find(element => element.route == currentPath) ?? null;
    this.mainElement = mainElement;
  }

  get menuElementsToShow(): MenuElement[] {
    return this.menuElements.filter(element => !element.disabled);
  }

}
